export const questions = [
    {
        id: 1,
        title: "What is BaiSocialX?",
        answer: "SocialX is a community-driven social media platform allowing users to publish photo and video content. It has many similarities to established social media platforms such as Facebook and Instagram, but there is one major difference: SocialX is a decentralised blockchain platform where everyone can earn cryptocurrency SOCX token rewards.",
     },

     {
        id: 2,
        title: "How Will BaiSocialX Achieve Decentralization?",
        answer: "We believe in decentralized networks. SocialX will push forward the vision of a decentralized future by accomplishing tasks",
        
     },

     {
        id: 3,
        title: "When Will BaiSocialX Launch?",
        answer: "The launch date has not yet been announced. You can track the project progress in our interactive roadmap and by reading our Medium blog post updates.",
        
     },

     {
        id: 4,
        title: "Are There Any Airdrops?",
        answer: "There are no airdrops.",
        
     },

     {
        id: 5,
        title: "Are There Any Bounties?",
        answer: "There are no airdrops.",
        
     },


]